import { createSlice } from "@reduxjs/toolkit";

const recommendedPlansSlice = createSlice({
  name: "recommendedPlan",
  initialState: {},
  reducers: {
    updateRecommendedPlan: {
      reducer: (state, action) => {
        return Object.assign({}, state, action.payload);
      },
      prepare: (plan) => {
        return {
          payload: {
            ...plan,
            // deprecated properties:
            get duration_in_months() {
              console.error(
                "duration_in_months is deprecated!\nUse billing_cycle_in_months or getCourseDuration in calculateGoals.js"
              );
              return plan.duration_in_months;
            },
          },
        };
      },
    },
  },
});

export const { updateRecommendedPlan } = recommendedPlansSlice.actions;

export default recommendedPlansSlice.reducer;
